module.exports = __webpack_public_path__ + "static/award1-43d27be8dd19db1cabc2569772d11a7f.png";